/**
 * Created by 杨达权 on 2018/4/11.
 */

import {config, request} from 'Utils';

/* 发运含折让报表 */
export function getShipmentReportList(param) {
    return request(`${config.server}/api/v1/dms/shipmentReport/list`, {
        method: 'post',
        body: param
    })

}

/* 客户应收查询数据报表 */
export function getCustomerReceivableList(param) {
    return request(`${config.server}/api/v1/dms/customerReceivable/list`, {
        method: 'post',
        body: param
    })

}

/* 客户开票情况查询数据报表 */
export function getCustomerInvoiceList(param) {
    return request(`${config.server}/api/v1/dms/customerInvoice/list`, {
        method: 'post',
        body: param
    })
}

/* 客户开票情况明细查询数据报表 */
export function getCustomerInvoiceDetail(param) {
    return request(`${config.server}/api/v1/dms/customerInvoice/detail`, {
        method: 'post',
        body: param
    })
}

/* 客户未开票明细查询 */
export function getCustomerNoInvoice(param) {
    return request(`${config.server}/api/v1/dms/customerInvoice/noInvoiceLine`, {
        method: 'post',
        body: param
    })
}

/* 客户应收查询数据报表详情 */
export function getCustomerReceivableDetail(param) {
    return request(`${config.server}/api/v1/dms/customerReceivable/detail`, {
        method: 'post',
        body: param
    })
}

/* 导出客户开票情况数据报表 */
export function customerInvoiceExportExcel(param) {
    return request(`${config.server}/api/v1/dms/customerInvoice/exportExcel`, {
        method: 'get',
        body: param
    })

}

/* 导出客户开票情况明细报表 */
export function customerInvoiceDetailExportExcel(param) {
    return request(`${config.server}/api/v1/dms/customerInvoice/detailExportExcel`, {
        method: 'get',
        body: param
    })

}

/* 导出客户应收查询数据报表 */
export function customerReceivableExportExcel(param) {
    return request(`${config.server}/api/v1/dms/customerReceivable/exportExcel`, {
        method: 'get',
        body: param
    })

}

/* 客户回款查询数据报表 */
export function getCustomerReceiptList(param) {
    return request(`${config.server}/api/v1/dms/customerReceipt/list`, {
        method: 'post',
        body: param
    })
}

/* 导出客户回款查询数据报表 */
export function getCustomerReceiptListExportExcel(param) {
    return request(`${config.server}/api/v1/dms/customerReceipt/exportExcel`, {
        method: 'get',
        body: param
    })
}

/*获取购销单位数据*/
export function getGouXiaoUnitList(param) {
    return request(`${config.server}/api/v1/dms/tzOrderSync/getGouXiaoUnit`, {
        method: 'post',
        body: {...param}
    });
}

/*获取购销单位数据 张青富*/
export function dmsPurchaseList(param) {
    return request(`${config.server}/api/v1/dms/dmsPurchase/list`, {
        method: 'post',
        body: {...param}
    });
}

// export function getShipmentReportList(param) {
//     return request(`${config.server}/api/v1/dms/shipmentReport/list`, {
//       method: 'post',
//       body: param,
//     });
//   }
/**
 * 折扣池明细查询列表
 * */
export function discountType(param) {
    return request(`${config.server}/api/v1/dms/discountDetail/discountType`, {
        method: 'post',
        body: param
    });
}

/**
 * 折扣池明细查询列表
 * */
export function discountDetail(param) {
    return request(`${config.server}/api/v1/dms/discountDetail/list`, {
        method: 'post',
        body: param
    });
}

/**
 * 导出折扣池明细查询列表
 * */
export function discountDetailExportExcel(param) {
    return request(`${config.server}/api/v1/dms/discountDetail/exportExcel`, {
        method: 'get',
        body: param
    });
}

/**
 * 开单含折让报表
 * 列表查询
 * */
export function openSingleFold(param) {
    return request(`${config.server}/api/v1/dms/orderReport/list`, {
        method: 'post',
        body: param,
    });
}

/**
 * 特殊发运申请
 * 列表查询
 * */
export function deffDeliveryOffer(param) {
    return request(`${config.server}/api/v1/dms/orderReport/deffDeliveryOffer`, {
        method: 'post',
        body: param,
    });
}

/**
 * 结算明细查询
 * 列表查询
 * */
export function settleDetailList(param) {
    return request(`${config.server}/api/v1/dms/orderReport/settleDetailList`, {
        method: 'post',
        body: param,
    });
}

/**
 * 发票池退货关联报表
 * 列表查询
 * */
export function taxReturn(param) {
    return request(`${config.server}/api/v1/dms/orderReport/taxReturn`, {
        method: 'post',
        body: param,
    });
}

/**
 * 头三个字段
 * 列表查询
 * */
export function threeHead(param) {
    return request(`${config.server}/api/v1/dms/discountDetail/balance`, {
        method: 'post',
        body: param,
    });
}

/**
 * 报表类型
 * */
export function getReportType(param) {
    return request(`${config.server}/api/v1/dms/dictionayDependent/sKeylist`, {
        method: 'get',
        body: param,
    });
}


/**
 *  产品线
 * */
export function getProductLine(param) {
    return request(`${config.server}/api/v1/dms/dictionayDependent/sKeylist`, {
        method: 'get',
        body: param,
    });
}


/**
 *  采购报表_说明
 *  {
    "channelCode": "ALL", //渠道编码默认ALL，如WJH，HY数据取自/xweb/api/v1/dms/homePage/channel接口（必填）
    //type和（startDate、endDate）二选一必填
    "type": 2, //日期筛选类型（1：今日；2：周；3：月；4：季度；5：年）
    "startDate": "2020-08-15 00:00:00", //查询开始时间
    "endDate": "2020-08-15 00:00:00"  //查询结束时间
}
 * */
export function purchasingReport(param) {
    return request(`${config.server}/api/v1/dms/orderReport/purchasingReport`, {
        method: 'post',
        body: param,
    });
}

/**
 *  财务报表_说明
 *  {
    "channelCode": "ALL", //渠道编码默认ALL，如WJH，HY数据取自/xweb/api/v1/dms/homePage/channel接口（必填）
}
 * */
export function financialReport(param) {
    return request(`${config.server}/api/v1/dms/orderReport/financialReport`, {
        method: 'post',
        body: param,
    });
}





// WEBPACK FOOTER //
// ./src/service/reportForm/index.js